import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Apple: React.FC<IconProps> = ({
  color = '#fff',
  size = 21,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M14.353 0h.142c.114 1.41-.424 2.464-1.079 3.228-.642.757-1.52 1.493-2.943 1.381-.094-1.39.445-2.366 1.098-3.127C12.177.772 13.288.14 14.353 0zm4.304 14.68v.04c-.4 1.21-.97 2.248-1.665 3.21-.635.874-1.413 2.05-2.803 2.05-1.2 0-1.998-.772-3.228-.793-1.302-.021-2.017.645-3.207.813h-.406c-.874-.127-1.58-.819-2.093-1.442-1.515-1.843-2.686-4.223-2.903-7.268v-.895c.092-2.18 1.15-3.952 2.559-4.811.743-.457 1.764-.846 2.901-.672.488.075.986.242 1.422.407.414.16.931.441 1.421.426.332-.01.662-.182.997-.304.98-.354 1.94-.76 3.207-.57 1.522.23 2.603.907 3.27 1.95-1.288.82-2.305 2.054-2.132 4.163.155 1.915 1.269 3.036 2.66 3.697z"
      fill={color}
    />
  </svg>
)
